module.exports = __webpack_public_path__ + "img/swiper-bg__PC.2fcf0d2.png";